import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { LoginComponent } from "./login/login.component";
import { AuthGuard } from "./guards/auth.guard";
import { MarketplaceComponent } from "./marketplace/marketplace.component";
import { McredproComponent } from "./mcredpro/mcredpro.component";
import {ContactusComponent} from "./contactus/contactus.component";
import {FeaturesComponent} from "./features/features.component";

//import{LoginComponent} from './user-pages/login/login.component'

const routes: Routes = [

  { path: "", redirectTo:"mcredpro", pathMatch: "full" },
  { path: "mcredpro", component: McredproComponent  },
  { path: "contactus", component: ContactusComponent},
  { path: "features", component: FeaturesComponent},

  {
    path: "dashboard",
    canActivate: [AuthGuard],
    component: DashboardComponent,
  },

  { path: "login", component: LoginComponent },
  {
    path: "marketplace",
    canActivate: [AuthGuard],
    component: MarketplaceComponent,
  },
  {
    path: "catlog",
    loadChildren: () =>
      import("./catlog/catlog.module").then((m) => m.CatlogModule),
  },
  {
    path: "design",
    loadChildren: () =>
      import("./design/design.module").then((m) => m.DesignModule),
  },
  {
    path: "sales",
    loadChildren: () =>
      import("./sales/sales.module").then((m) => m.SalesModule),
  },

  {
    path: "orders",
    loadChildren: () =>
      import("./orders/orders.module").then((m) => m.OrdersModule),
  },

  {
    path: "feedback",
    loadChildren: () =>
      import("./feedback/feedback.module").then((m) => m.FeedbackModule),
  },
  {
    path: "customers",
    loadChildren: () =>
      import("./customers/customers.module").then((m) => m.CustomersModule),
  },
  {
    path: "marketing",
    loadChildren: () =>
      import("./marketing/marketing.module").then((m) => m.MarketingModule),
  },
  {
    path: "analytics",
    loadChildren: () =>
      import("./analytics/analytics.module").then((m) => m.AnalyticsModule),
  },
  {
    path: "delivery",
    loadChildren: () =>
      import("./delivery/delivery.module").then((m) => m.DeliveryModule),
  },
  { path: "**", redirectTo: "/mcredpro", pathMatch: "full" },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
